import React from 'react'
import createReactClass from 'create-react-class'
import logo from '../assets/images/connect-api-logo.png'
import {ENV_KEY, getSessionKey, TOKEN_KEY, USERNAME_KEY} from '../util/storage'
import './nav-bar.scss'
import RefreshTokenPanel from '../containers/refresh-token-panel-container'
import {getTokenExpireCountDown, copyToClipboard} from '../util/helpers'
import InfoPanel from './info-panel'

export default createReactClass({
  getInitialState () {
    return {
      timer: getTokenExpireCountDown(),
      renderInfoPanel: false,
      infoMessage: '',
      infoError: false,
    }
  },
  componentWillMount () {
    this.startTimer()
  },
  setTimerValue () {
    // to make sure that it displays the correct timer
    // we redetermine the value from the current time
    // instead of reducing the timer value by 1
    let timer = getTokenExpireCountDown()
    if (timer <= 0) {
      this.stopTimer()
    } else {
      this.setState({timer})
    }
  },
  startTimer () {
    // as asynchronous operations delay the callbacks
    // invocation, we set the interval time to be 30 secs
    // instead of 60secs.
    this.interval = setInterval(this.setTimerValue, 500 * 60)
  },
  stopTimer () {
    clearInterval(this.interval)
    this.props.logOut(this.props.history, true)
  },
  onSignOutClick () {
    this.props.logOut(this.props.history)
  },
  onCopyTokenToClipboard () {
    let success = copyToClipboard(getSessionKey(TOKEN_KEY), document)
    if (success) {
      this.setState({renderInfoPanel: true, infoMessage: 'Token copied to clipboard', infoError: false})
    } else {
      this.setState({renderInfoPanel: true, infoMessage: 'Token not copied to clipboard', infoError: true})
    }
  },
  unMountInfoPanel () {
    this.setState({renderInfoPanel: false, infoError: false, infoMessage: ''})
  },
  renderInfoPanelCheck () {
    return this.state.renderInfoPanel ? (
      <InfoPanel message={this.state.infoMessage} unMountInfoPanel={this.unMountInfoPanel} infoError={this.state.infoError}/>
    ) : false
  },
  render () {
    return (
      <div className='nav-bar-ctr'>
        <nav className="navbar navbar-default no-border-radius custom-navbar">
          <div className="nav-bar-top-grid"></div>
          <div className="container-fluid">
            <div className="logo-grid col-lg-offset-0 col-lg-2 col-md-offset-0 col-md-2 col-sm-offset-0 col-sm-2 col-xs-offset-2 col-xs-10">
              <img alt="Brand" className="header-logo" src={logo} />
            </div>
            <div className="info-grid col-lg-offset-7 col-lg-3 col-md-offset-7 col-md-3 col-sm-offset-5 col-sm-5 col-xs-offset-1 col-xs-11">
              <ul className="csc-nav">
                <li className="dropdown">
                  <a className="dropdown-toggle flex-display no-gutter" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                    <div className='icon-grid col-lg-2 col-md-3 col-sm-2'>
                      <span className="fa fa-user-o fa-2"/>
                    </div>
                    <div className='user-info-grid col-lg-10 col-md-9 col-sm-10'>
                      <div className='details-row'>{getSessionKey(USERNAME_KEY)}</div>
                      <div className="environment details-row">{getSessionKey(ENV_KEY)}</div>
                      <div className='details-row'><span className="token-expiry-text">Token Expires in </span><span className="token-expiry-time">{this.state.timer}</span> Mins</div>
                    </div>
                  </a>
                  <ul className="dropdown-menu">
                    <RefreshTokenPanel/>
                    <li><a onClick={this.onCopyTokenToClipboard}>Copy token to clipboard</a></li>
                    <li className='dotted-line'></li>
                    <li><a onClick={this.onSignOutClick}>Sign Out</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        {this.renderInfoPanelCheck()}
      </div>
    )
  },
  componentDidMount () {
    if (this.state.timer <= 0) {
      this.stopTimer()
    }
  },

  componentWillReceiveProps (nextProps) {
    if (nextProps.isTokenRefreshed) {
      this.setState({
        timer: getTokenExpireCountDown(),
        infoError: false,
        infoMessage: 'Token refreshed',
        renderInfoPanel: true,
      })
    }
  },
})



// WEBPACK FOOTER //
// ./src/components/nav-bar.js